import './nuevoStroLight.css';
import { Link } from 'react-router-dom';

export default function ModuloDenunciaChoquesLight({ stro, sicobe, frente, carga2, pagosAnteriores, cobert }) {
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const year = date.getUTCFullYear();
    return `${day}/${month}/${year}`;
  }

  const openInNewTab = (url, e) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <section className='mainStroLightIzq'>
      <div className='d-flex gap-3' style={{ marginTop: '0px' }}>
        <div className='d-flex w-100'>
          <span className='spanBurbujaTextoStroLight'>Fecha Stro</span>
          <div className='burbujaTextoStroLight'>{formatDate(stro?.fechaStro)}</div>
        </div>
        <div className='d-flex w-100'>
          <span className='spanBurbujaTextoStroLight'>Fecha Den</span>
          <div className='burbujaTextoStroLight'>{formatDate(stro?.fechaDenuncia)}</div>
        </div>
      </div>
      <div className='d-flex gap-3' style={{ marginTop: '25px' }}>
        <div className='d-flex w-100'>
          <span className='spanBurbujaTextoStroLight'>Poliza</span>
          <div className='burbujaTextoStroLight'>
            <Link onClick={e => openInNewTab(`https://www.agsnet.com.ar/muestro-polizas2.php?prop=${stro?.qnx?.ados_nro_cc}&rtn=consulta-polizas`)}>{stro?.qnx?.ados_poliza}</Link>
          </div>
        </div>
        <div className='d-flex  w-100'>
          <span className='spanBurbujaTextoStroLight'>Productor</span>
          <div className='burbujaTextoStroLight'>
            {stro?.productor?.pro_productor} - {stro?.productor?.pro_raz_social}
          </div>
        </div>
      </div>
      <div className='' style={{ marginTop: '25px' }}>
        <div className='d-flex w-100'>
          <span className='spanBurbujaTextoStroLight'>Nombre Aseg</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_nom_aseg}</div>
        </div>
      </div>
      <div className='' style={{ marginTop: '25px' }}>
        <div className='d-flex w-100'>
          <span className='spanBurbujaTextoStroLight'>Direccion Aseg</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_dir_aseg}</div>
        </div>
      </div>
      <div className='d-flex gap-3' style={{ marginTop: '25px' }}>
        <div className='d-flex w-100'>
          <span className='spanBurbujaTextoStroLight'>Localidad Aseg</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_loc_aseg}</div>
        </div>
        <div className='d-flex w-100'>
          <span className='spanBurbujaTextoStroLight'>C.P</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_cdp_aseg}</div>
        </div>
      </div>
      <div className='d-flex gap-3' style={{ marginTop: '25px' }}>
        <div className='d-flex w-100'>
          <span className='spanBurbujaTextoStroLight'>Patente</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_patente}</div>
        </div>
        <div className='d-flex w-100'>
          <span className='spanBurbujaTextoStroLight'>N° Motor</span>
          <div className='burbujaTextoStroLight'>{stro?.qnx?.ados_motor}</div>
        </div>
      </div>
      <div className='' style={{ marginTop: '25px' }}>
        <div className='d-flex w-100'>
          <span className='spanBurbujaTextoStroLight'>Tipo vehiculo</span>
          <div className='burbujaTextoStroLight'>{stro?.tipoAseg}</div>
        </div>
      </div>
      <div className='' style={{ marginTop: '25px' }}>
        <div className='d-flex w-100'>
          <span className='spanBurbujaTextoStroLight'>Marca/Modelo</span>
          <div className='burbujaTextoStroLight'>
            {stro?.qnx?.ados_vehiculo} - {stro?.qnx?.ados_modelo}
          </div>
        </div>
      </div>
      <div style={{ marginTop: '25px' }}>
        <div className='d-flex w-100'>
          <label className='spanBurbujaTextoStroLight'>Stros Ant</label>
          <div className='burbujaTextoStroLight'>{stro?.mismaPatente?.length > 1 ? 'SI' : 'NO'}</div>
        </div>
      </div>
      {stro?.qnx?.ados_gruapp !== 0 && (
        <div style={{ marginTop: '25px' }}>
          <div className='d-flex w-100'>
            <span className='spanBurbujaTextoStroLight'>ADICIONAL GRUAPP</span>
            <div className='burbujaTextoStroLight'>SI</div>
          </div>
        </div>
      )}
      <h5 className='' style={{ marginTop: '20px' }}>
        DATOS 3RO
      </h5>
      <div className='d-flex gap-3' style={{ marginTop: '25px' }}>
        <div className='d-flex w-100'>
          <span className='spanBurbujaTextoStroLight'>Patente</span>
          <div className='burbujaTextoStroLight'>{stro?.terceroViejo ? stro.terceroViejo.patente : null}</div>
        </div>
        <div className='d-flex w-100'>
          <span className='spanBurbujaTextoStroLight'>Nombre Tercero</span>
          <div className='burbujaTextoStroLight'>{stro.conductorTercero1 ? stro.conductorTercero1 : stro?.terceroViejo ? stro.terceroViejo.nombre : null}</div>
        </div>
      </div>
      <div className='' style={{ marginTop: '25px' }}>
        <div className='d-flex w-100'>
          <span className='spanBurbujaTextoStroLight'>Fecha Rec Viejo</span>
          <div className='burbujaTextoStroLight'>{stro?.terceroViejo ? stro.terceroViejo.fechaRec : null}</div>
        </div>
      </div>
    </section>
  );
}
